<!-- 身份证信息列表（数据由刷卡登录自动录入） -->
<template>
  <section>
    <!--工具条（按钮由后台权限配置下发）-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--筛选区域-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 10px;">
      <el-form :inline="true" :model="filters" @submit.native.prevent>
        <el-form-item label="关键字">
          <el-input v-model="filters.key" placeholder="姓名或身份证号" clearable
            style="width: 220px;" @keyup.enter.native="onSearch" @clear="onSearch">
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="lists" v-loading="listLoading" style="width: 100%"
      @row-click="selectCurrentRow" ref="table" class="custom-tbl" border>
      <el-table-column label="照片" width="80" align="center">
        <template slot-scope="scope">
          <img v-if="scope.row.Photo" :src="resolveImgUrl(scope.row.Photo)"
            style="width: 48px; height: 60px; object-fit: cover; cursor: pointer; display: block; margin: 0 auto;"
            @click="showPhoto(scope.row)" />
          <span v-else>无</span>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="姓名" width="100" show-overflow-tooltip></el-table-column>
      <el-table-column label="性别" width="70" align="center" :formatter="formatSex"></el-table-column>
      <el-table-column prop="Nation" label="民族" width="80" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Birth" label="出生日期" width="110" :formatter="formatDate"></el-table-column>
      <el-table-column prop="IdCardNo" label="身份证号" width="190" show-overflow-tooltip></el-table-column>
      <el-table-column prop="Address" label="住址" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="IssuingAuthority" label="签发机关" width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="ValidFrom" label="有效期起" width="110" :formatter="formatDate"></el-table-column>
      <el-table-column prop="ValidTo" label="有效期止" width="110" :formatter="formatDate"></el-table-column>
      <el-table-column prop="FirstSwipeTime" label="首次刷卡时间" width="160" :formatter="formatTime" sortable></el-table-column>
      <el-table-column prop="LastSwipeTime" label="最近刷卡时间" width="160" :formatter="formatTime" sortable></el-table-column>
    </el-table>

    <!--分页-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="prev, pager, next, jumper, total" @current-change="handleCurrentChange"
        :page-size="pagesize" :total="total" :current-page="page" style="float: right">
      </el-pagination>
    </el-col>
  </section>
</template>

<script>
import util from "../../../util/date";
import { getIdCardInfoListPage, removeIdCardInfo, BaseApiUrl } from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: { key: "" },
      lists: [],
      total: 0,
      page: 1,
      pagesize: 20,
      listLoading: false
    };
  },
  methods: {
    // 照片相对路径拼全地址（后端存 /IdCardPhotos/xxx.jpg）
    resolveImgUrl(path) {
      if (!path) return "";
      return path.startsWith("http") ? path : BaseApiUrl + path;
    },
    // 点击照片放大预览
    showPhoto(row) {
      if (!row.Photo) return;
      this.$alert(
        '<img src="' + this.resolveImgUrl(row.Photo) + '" style="width: 320px; display: block; margin: 0 auto;" />',
        (row.Name || "") + " - 身份证照片",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "关闭"
        }
      ).catch(() => {});
    },
    onSearch() {
      this.page = 1;
      this.getList();
    },
    onReset() {
      this.filters = { key: "" };
      this.page = 1;
      this.getList();
    },
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({ message: "请选择要删除的一行数据！", type: "error" });
        return;
      }
      this.$confirm("确认删除该身份证信息吗?", "提示", { type: "warning" })
        .then(() => {
          this.listLoading = true;
          removeIdCardInfo({ id: row.Id }).then((res) => {
            this.listLoading = false;
            if (res && res.data) {
              if (res.data.success) {
                this.$message({ message: res.data.msg || "删除成功", type: "success" });
              } else {
                this.$message({ message: res.data.msg, type: "error" });
              }
            }
            this.currentRow = null;
            this.getList();
          });
        })
        .catch(() => {});
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
      }
    },
    callFunction(item) {
      if (item.Func === "onSearch") {
        this.onSearch();
      } else {
        this[item.Func].apply(this, item);
      }
    },
    formatSex(row, column) {
      return row.Sex === 1 ? "男" : row.Sex === 0 ? "女" : "未知";
    },
    formatDate(row, column, cellValue) {
      if (!cellValue) return "";
      return util.formatDate.format(new Date(cellValue), "yyyy-MM-dd");
    },
    formatTime(row, column, cellValue) {
      if (!cellValue) return "";
      return util.formatDate.format(new Date(cellValue), "yyyy-MM-dd hh:mm:ss");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let para = {
        page: this.page,
        intPageSize: this.pagesize,
        key: this.filters.key || ""
      };
      this.listLoading = true;
      getIdCardInfoListPage(para).then((res) => {
        if (res && res.data) {
          if (res.data.response != null) {
            var result = res.data.response;
            this.total = result.dataCount;
            this.pagesize = result.PageSize;
            this.lists = result.data || [];
          } else if (!res.data.success) {
            this.$message.error(res.data.msg);
            this.lists = [];
            this.total = 0;
          } else {
            this.lists = [];
            this.total = 0;
          }
        }
        this.listLoading = false;
      }).catch(() => {
        this.listLoading = false;
      });
    }
  },
  mounted() {
    this.getList();
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
